export default {
  // 控制塔面板
  title: 'Wo AI 控制塔面板',
  switchToLight: '切换到浅色主题',
  switchToDark: '切换到深色主题',
  systemStatus: '订单流转正常',

  // 时间范围选择
  today: '今日',
  thisWeek: '本周',
  thisMonth: '本月',
  thisYear: '本年',
  custom: '自定义',

  // 数据范围选择
  myself: '本人',
  myDept: '部门',
  myCompany: '分公司',
  myTenant: '租户',

  // 订单来源
  priceQuery: '运价查询创建',
  inquiry: '询价单创建',
  quotation: '报价单创建',
  booking: '创建订舱',
  apiSyncCargoWare: 'API同步(CargoWare)',

  // 数据概览
  totalOrders: '总订单数',
  ordersInTransit: '在途订单',
  pendingTasks: '待处理任务',
  overdueTasks: '逾期任务',
  anomalyOrders: '异常预警订单',
  viewDetails: '查看详情',

  // 实时数据
  realtimeOrders: '实时订单',
  realtimeTasks: '实时任务',
  noRealtimeOrders: '暂无实时订单',
  noRealtimeTasks: '暂无实时任务',
  globalOrderFlow: '全球订单流向',

  // 图表
  customsAnomalyStats: '通关异常订单统计',
  inquiryDealTrend: '询价成交趋势',
  hotInquiryRanking: '热门询价排行榜 TOP10',
  salesQuoteEfficiencyRanking: '销售报价时效排行榜 TOP10',
  customerOrdersRanking: '成交订单量客户排行榜 TOP10',

  // 任务相关
  taskDetails: '任务详情',
  viewTaskDetails: '查看任务详情',
  viewOrderDetails: '查看订单详情',
  pendingTasksList: '待处理任务列表',
  overdueTasksList: '逾期任务列表',
  deadline: '截止时间',
  overdueTime: '逾期时间',
  totalTasks: '共 {count} 个任务',
  totalOverdueHours: '逾期总时长：{hours}小时',
  loading: '加载中...',
  noMoreData: '没有更多数据了',

  // 自定义日期范围
  selectCustomDateRange: '选择自定义时间范围',
  startDate: '开始日期',
  endDate: '结束日期',
  dateRangeNote: '注意：时间跨度不能超过1年',
  dateRangeExceedsOneYear: '时间跨度不能超过1年',
  pleaseSelectValidDateRange: '请选择有效的日期范围',

  // 错误提示
  loadInquiryDealTrendError: '加载询价成交趋势数据失败',
  loadPlatformIndicesError: '加载平台指数数据失败',
  loadTaskListError: '加载任务列表失败',
  taskNotFound: '未找到该任务',
  loadTaskDetailsError: '加载任务详情失败',

  // 状态提示
  loadingData: '加载中...',
  noPermission: '无权限查看',
  dataLoadFailed: '数据加载失败',
  noData: '暂无数据',
  selectDataRange: '选择数据范围',

  // 优先级
  priorityHigh: '高',
  priorityMedium: '中',
  priorityLow: '低',

  // 时间单位
  hours: '小时',
  days: '天',
  orders: '票订单',

  // 按钮文本
  collapseDetails: '收起指数详情',
  expandDetails: '展开指数详情',

  // 图表单位和标签
  quantity: '数量',
  inquiryQuantity: '询价数量',
  dealQuantity: '成交数量',
  inquiryTimes: '次询价',
  average: '平均',
  orderCount: '订单'
}
